import { Filter } from '@ais-ui/websockets';

export const getFilterType = (filter: Filter): string => {
  // Define an array of your operator symbols
  const operators = ['=', '!=', '>', '<', '>=', '<=', ' '];

  let earliestOperatorIndex = filter.filter.length; // Start with the maximum possible index
  let operatorFound = false;

  // Iterate over each operator to find the earliest occurrence
  for (const operator of operators) {
    const operatorIndex = filter.filter.indexOf(operator);
    if (operatorIndex !== -1 && operatorIndex < earliestOperatorIndex) {
      earliestOperatorIndex = operatorIndex;
      operatorFound = true;
    }
  }

  const filterString = filter.filter.replace('(', '').replace(')', '');

  // If an operator is found, split the string at that index
  const filterType = operatorFound
    ? filterString.substring(0, earliestOperatorIndex)
    : 'Unknown';

  return filterType.trim();
};
